import React, { useContext } from 'react'
import { EPCRContext } from './EPCR'
import { Button } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { isFullLayoutMode } from './formTypes'

const NextButton = ({ newModule }) => {
  const { setSelectedEPCRModule, formValues } = useContext(EPCRContext)

  //TODO: Change naming convention of each module so that the module name can be updated from one place.
  if (!isFullLayoutMode(formValues.mode)) {
    return null
  }
  return (
    <Button
      fullWidth
      color="primary"
      variant="contained"
      endIcon={<ArrowForwardIcon />}
      onClick={() => setSelectedEPCRModule(newModule ?? 'Incident')}
      sx={{
        borderRadius: 2,
        py: 1,
        fontWeight: 700,
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': { boxShadow: 'none' },
      }}
    >
      Next{newModule ? ` — ${newModule}` : ''}
    </Button>
  )
}

export default NextButton
